import React from 'react';
import i18n from '../../i18n';
import LoadingOverlayButton, { type LoadingOverlayButtonProps } from '../../component/button/loading-overlay-button.component';
import { ReactComponent as SaveIcon } from '../../static/images/svg/ic_round-save.svg';
import './scss/sub-function-project-setting-save-button.scss';

export type SubFunctionProjectSettingSaveButtonProps = Omit<
    LoadingOverlayButtonProps,
    'children' | 'variant' | 'color' | 'startIcon'
> & {
    /** 按钮主文案的 i18n key，默认「保存修改」 */
    labelI18nKey?: string;
    /** 左侧保存图标边长（px），Figma 1871:54008 为 32 */
    iconSize?: number;
};

const DEFAULT_LABEL_KEY = 'kwa_setting_page_save_changes';
const DEFAULT_ICON_SIZE = 32;

/**
 * 云 RBP 子功能「项目设置」各 Tab 页顶栏共用的「保存修改」按钮：左侧图标 + 文案、统一样式；
 * 保存中由 `LoadingOverlayButton` 提供遮罩与转圈，避免仅 disabled 时无反馈。
 */
export default function SubFunctionProjectSettingSaveButton(
    props: SubFunctionProjectSettingSaveButtonProps,
): JSX.Element {
    const {
        labelI18nKey = DEFAULT_LABEL_KEY,
        iconSize = DEFAULT_ICON_SIZE,
        loadingIndicatorSize = 24,
        className,
        ...rest
    } = props;
    const mergedClass = ['sub-function-project-setting-save-btn', className].filter(Boolean).join(' ');

    return (
        <LoadingOverlayButton
            className={mergedClass}
            variant="contained"
            color="primary"
            disableElevation
            loadingIndicatorSize={loadingIndicatorSize}
            startIcon={<SaveIcon width={iconSize} height={iconSize} aria-hidden />}
            {...rest}
        >
            {i18n.t(labelI18nKey)}
        </LoadingOverlayButton>
    );
}
